
export enum EmployeeShowType {
  Employee = 0,
  Trainer = 1,
  Doctor = 2
}
